module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: _vm.themeColor,
    attrs: {
      "dark": "",
      "dense": "",
      "flat": ""
    }
  }, [_vm._t("buttons-before"), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("pagetoolbar:homeclicked")
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _vm._t("buttons-after"), _vm._v(" "), (_vm.extended) ? _c('v-text-field', {
    staticClass: "white--text",
    attrs: {
      "slot": "extension",
      "dark": "",
      "prepend-icon": "search"
    },
    slot: "extension",
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extended !== true),
      expression: "extended!==true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.extended = true
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extended === true),
      expression: "extended===true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.searchText = "";
        _vm.extended = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _vm._t("toolbar-right")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7930a06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageToolbar.vue
// module id = 1509
// module chunks = 9